import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { AkoyaDTO } from './useAkoyaAccountsQuery';
import { ACCOUNTS_QUERY_KEY } from '../AccountsConstants';
import { ACCOUNT_PREFERENCES_QUERY_KEY } from './useAccountsQuery';
import { MANAGE_LINKS_QUERY_KEY } from './useLinksQuery';

interface AkoyaUnLinkBody {
  institutionName: string;
  akoyaTokenId: number;
}

const unlinkAkoyaAccount = (clientId: number) => ({
  institutionName,
  akoyaTokenId,
}: AkoyaUnLinkBody) =>
  authFetch(
    urlWithParams(`/Consumer/AkoyaAccountsUpdate/Unlink`, {
      clientId,
      institutionName,
      akoyaTokenId,
    }),
    {
      method: 'POST',
    },
  );

export const useAkoyaUnlinkMutation = () => {
  const clientId = useClientId();

  const queryClient = useQueryClient();

  return useMutation(unlinkAkoyaAccount(clientId), {
    onSuccess: (data, variables) => {
      const queryKey = queryKeys.akoyaAccounts(clientId);
      const { Accounts } = queryClient.getQueryData(queryKeys.akoyaAccounts(clientId)) as AkoyaDTO;

      queryClient.setQueryData(queryKey, {
        Accounts: Accounts.filter(({ AkoyaTokenId }) => AkoyaTokenId !== variables.akoyaTokenId),
      });
      queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY, ACCOUNT_PREFERENCES_QUERY_KEY]);
      queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY, MANAGE_LINKS_QUERY_KEY]);
    },
  });
};
